import { useReducer } from 'react'
import type { SortingState } from '@tanstack/react-table'
import type { Filter } from './types'
import { DEFAULT_ROWS_PER_PAGE } from '../../constants'
import { RowsPerPageCount } from '../../components/RowsPerPage/types'

export function useTableFilter(
  sortBy: SortingState,
  rowCount?: RowsPerPageCount,
): [Filter, React.Dispatch<Partial<Filter>>] {
  const [filters, setFilters] = useReducer(
    (state: Filter, newState: Partial<Filter>) => ({ ...state, ...newState }),
    {
      currentPageIdx: 0,
      rowCount: rowCount ?? DEFAULT_ROWS_PER_PAGE,
      sortBy,
    },
  )

  return [filters, setFilters]
}
